"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortArrows = exports.SortArrowDown = exports.SortArrowUp = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const toLower_1 = tslib_1.__importDefault(require("lodash/fp/toLower"));
const SortArrowUp = () => (0, jsx_runtime_1.jsx)("span", { className: 'sort-icon sort-asc' });
exports.SortArrowUp = SortArrowUp;
const SortArrowDown = () => (0, jsx_runtime_1.jsx)("span", { className: 'sort-icon sort-desc' });
exports.SortArrowDown = SortArrowDown;
const SortArrows = ({ direction }) => (0, jsx_runtime_1.jsx)("span", { className: `sort-arrows sort-${(0, toLower_1.default)(direction)}` });
exports.SortArrows = SortArrows;
